import script from "./purchaseNotes.vue?vue&type=script&setup=true&lang=ts"
export * from "./purchaseNotes.vue?vue&type=script&setup=true&lang=ts"

import "./purchaseNotes.vue?vue&type=style&index=0&id=47902d12&scoped=true&lang=stylus"

import exportComponent from "D:\\project\\web\\vysa_wifi_h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47902d12"]])

export default __exports__